// src/components/Funnels/SkillToSaleQuizFunnel/QuestionCard.tsx
import React from "react";
import { QuizData } from "./quizLogic"; // <- updated import

export interface Question {
  id: keyof QuizData;
  title: string;
  subtitle: string;
  icon: React.ReactElement;
  type: string;
  options: string[];
}

export interface QuestionCardProps {
  question: Question;
  selectedValue: string;
  onSelect: (value: string) => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({
  question,
  selectedValue,
  onSelect,
}) => {
  return (
    <div>
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-brandLightNavy rounded-full flex items-center justify-center mx-auto mb-4">
          {question.icon}
        </div>
        <h2 className="text-2xl font-bold text-brandNavy mb-2">
          {question.title}
        </h2>
        <p className="text-sm text-mutedGray">{question.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
        {question.options.map((option, index) => {
          const selected = selectedValue === option;
          return (
            <button
              key={index}
              onClick={() => onSelect(option)}
              className={`w-full p-3 rounded-lg border transition-all text-left flex items-center justify-between ${
                selected
                  ? "bg-brandNavy/5 border-brandNavy text-brandNavy shadow-sm"
                  : "bg-white border-lightBorder text-gray-700 hover:bg-gray-50"
              }`}
              style={{
                borderColor: selected ? "rgba(27,41,81,0.12)" : undefined,
              }}
            >
              <div className="flex items-center gap-3">
                <span className="font-medium">{option}</span>
              </div>

              {selected && (
                <div className="w-6 h-6 rounded-full bg-brandRed flex items-center justify-center text-white text-xs">
                  ✓
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;
